<template>
  <div>
    <top-header class="header"></top-header>
    <v-content class="content">
      <main-content></main-content>
    </v-content>
    <bottom-footer class="footer"></bottom-footer>
    <go-to></go-to>
  </div>
</template>

<script>
import "../../scss/custom.scss";
import GoTo from "./GoTo";
import TopHeader from "./TopHeader";
import MainContent from "./MainContent";
import BottomFooter from "./BottomFooter";

export default {
  name: "Home",

  components: {
    TopHeader,
    MainContent,
    BottomFooter,
    GoTo
  },

  data: () => ({
    visible: false,
    title: "广东省消防协会",
    slogan: "办公地址：广东省广州市天河区五山瘦狗岭路 483 号!</code>",
    userInfo: null,
    fixed: false,
    scrollTop: "",
    tab: null,
    // items: ["web", "shopping", "videos", "images", "news"],
    text:
      "广东省消防协会（英文缩写 GDFPA）成立于 1985 年，是经省民政厅依法登记成立的，由全省消防科技工作者、消防专业工作者及消防科研、大专院校、热心消防事业的各界人士以及消防安全重点单位、消防企业和中介组织等自愿参加和组成的学术性、行业性和非营利性社会团体，是发展我省消防事业的重要力量"
  }),
  methods: {}
};
</script>
<style>
.header {
  height: 168px;
  background-color: rgba(0, 0, 0, 0) !important;
}
.footer {
  height: 123px;
}
.content {
  min-height: calc(100vh - 168px - 123px);
}
</style>
